/** Default WebRTC / SIP trunk (Merapi) — shared by CallDialog standby + inbound registration */
export const MERAPI_SIP_WS_URI = "wss://merapi.latera.id/ws";
export const MERAPI_SIP_DOMAIN = "merapi.latera.id";
export const MERAPI_SIP_PASSWORD = "YeFEzMKbR6vYxJRiwkfAUN13zCSMcOc";

/**
 * URL to the ringtone looped while a genuine inbound INVITE is ringing.
 * Override by passing `ringtoneUrl` into `initPhone()`, or replace the asset
 * at `public/audio/ring.mp3` without touching code.
 */
export const MERAPI_SIP_RINGTONE_URL = "/audio/ring.mp3";

/**
 * `initPhone(config)` in use-jssip — logical shape (password from env/constant in app code):
 *   { wsUri, uri, password, username, unique_id | null, call_type: "default"|"whatsapp", caller_number?: string }
 * Optional: `ringtoneUrl` for inbound ring asset only.
 * `caller_number` is only sent on INVITE as `caller_number:` when `call_type` is `whatsapp` (ignored for default calls).
 * `unique_id` is stored and used as `X-Activity-Id` on INVITE when `makeCall` is called without an activity id.
 * UA is still created with register/session_timers in code (not part of this object).
 */
